<app-schedule-task-surfacedev-planning [projectTab]="projectTab()">
</app-schedule-task-surfacedev-planning>
<app-tab-header style="padding-top: 60px;">
  <div class="row">
    <div class="col-md-2 execution-schedule-header">
      Execution Schedule
    </div>
    <div class="col-md-10">
      @if (scheduleDataLoaded) {
      <div class="ms-auto" style="float: right">
        @if (working || loading) {
        <kendo-loader
          [type]="loader.type"
          [themeColor]="loader.themeColor"
          [size]="loader.size">
        </kendo-loader>
        }
        <button type="button" class="btn btn-warning" style="background-color: #f5f5f5; border-color: lightgrey; font-size: 0.875rem;" disabled>Sync Status: {{syncStatusMessage}}</button>
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.resetClock" [disabled]="disableSave" (click)="PrepareAndShowActionDialog(false, AllPhases)">Reset Schedule</button>&nbsp;
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save" [disabled]="disableSave" (click)="PrepareAndShowActionDialog(true, [])">Save &amp; Reschedule</button>&nbsp;
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel" [disabled]="disableSave" (click)="handleCancelButton()"> Cancel</button>
      </div>
      }
    </div>
  </div>
</app-tab-header>

@if (projectTab() && projectTab().ProjectId) {
<div kendoTooltip #tooltip="kendoTooltip" [showOn]="'hover'" filter='tr span' style="height:calc(100% - 60px)">
  <ag-grid-angular #agGridFF class="ag-theme-balham" style="height:100%;min-height:400px;" (gridReady)="onGridReady($event)" (firstDataRendered)="onFirstDataRendered($event)"
    [gridOptions]="gridOptions.gridOptions"
    [stopEditingWhenCellsLoseFocus]="false"
    (cellValueChanged)="onCellValueChanged($event)">
  </ag-grid-angular>
</div>
}
<div kendoDialogContainer></div>

@if (showActualDatesErrorDialog) {
<kendo-dialog title="Error Saving Actual Dates" maxWidth="50vw" maxHeight="40vh" (close)="this.showActualDatesErrorDialog = false;">
  <p style="margin: 10px;">Please fix the following activity's Actual Start / Actual Finish date</p>
  <br />
  @if (actualDateErrors.length > 0) {
  <ul class="mb-0 bullets">
    @for (error of actualDateErrors; track error; let i = $index) {
    <li style="margin-left: 20px; text-align: left">
      <span class="mb-0 no-bullets">{{ error }}</span>
    </li>
    }
  </ul>
  }
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="this.showActualDatesErrorDialog = false;">OK</button>
  </kendo-dialog-actions>
</kendo-dialog>
}

@if (showActionDialog) {
<kendo-dialog (close)="closeDialog()" [minWidth]="400">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em;">
      <kendo-svg-icon style="margin-top:-.1em;" [icon]="icons.attention" size="xlarge" themeColor="secondary"></kendo-svg-icon> {{ dialogTitle }}
    </div>
  </kendo-dialog-titlebar>
  <h4 style="margin: 30px; text-align: center; font-weight:bold">The Following Will Occur</h4>
  @if (dialogData.savingActivities) {
  <ul>
    <li>TOTAL Rows to Save: {{changedRowsToSave.length}}
    <li>PLANNED dates/durations to Save: {{dialogData.countOfPlannedToSave}}</li>
    <li>ACTUAL dates/durations to Save: {{dialogData.countOfActualToSave}}</li>
  </ul>
  }
  @if (dialogData.resyncingSchedule) {
  <ul>
    <li>{{dialogData.phaseActionsToBeAffected}} PLANNED Dates and Planned Durations will be reset to the Schedule Template</li>
    <li>{{dialogData.phaseActionsToBeAffected}} ACTUAL Dates will be cleared Out</li>
    <li>The Schedule may update because it depends on TODAY, which may be later than when originally created.</li>
  </ul>
  }
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="closeDialog()">Cancel</button>
    <button type="button" kendoButton (click)="continueWithAction()" themeColor="primary">OK
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
}